
export const ErrorToast = ({ message, show }) => {
  if (!show) return null;
  return (
    <div
      className={`fixed top-10 left-1/2 transform -translate-x-1/2 bg-red-600 text-white p-4 rounded-lg shadow-lg w-3/4 max-w-[18rem] text-center z-50 transition-all ${show ? 'opacity-100' : 'opacity-0'}`}
      style={{ transition: 'opacity 0.3s ease-in-out' }}
    >
      {message}
    </div>
  );
};
